$(document).ready(function () {
    // ======= 1 =======
    $('#g1_hour').keyup(function () {
        costCalculate('#g1_hour', '#g1_cost_per_hour');
        totalAmountCalculate('#g1_cost_per_hour', '#g1_num_stu', '#g1_discount_price', '#g1_total_amount')
    });
    $('#g1_num_stu').keyup(function () {
        discountCalculate('#g1_num_stu', '#g1_discount_price')
        totalAmountCalculate('#g1_cost_per_hour', '#g1_num_stu', '#g1_discount_price', '#g1_total_amount')
    });
    $('#g1_discount_price').keyup(function () {
        inputDiscount("#g1_cost_per_hour", "#g1_num_stu", "#g1_discount_price", "#g1_total_amount");
    });
    // ======= 2 =======
    $('#g2_hour').keyup(function () {
        costCalculate('#g2_hour', '#g2_cost_per_hour');
        totalAmountCalculate('#g2_cost_per_hour', '#g2_num_stu', '#g2_discount_price', '#g2_total_amount')
    });
    $('#g2_num_stu').keyup(function () {
        discountCalculate('#g2_num_stu', '#g2_discount_price')
        totalAmountCalculate('#g2_cost_per_hour', '#g2_num_stu', '#g2_discount_price', '#g2_total_amount')
    });
    $('#g2_discount_price').keyup(function () {
        inputDiscount("#g2_cost_per_hour", "#g2_num_stu", "#g2_discount_price", "#g2_total_amount");
    });
    // ======= 3 =======
    $('#g3_hour').keyup(function () {
        costCalculate('#g3_hour', '#g3_cost_per_hour');
        totalAmountCalculate('#g3_cost_per_hour', '#g3_num_stu', '#g3_discount_price', '#g3_total_amount')
    });
    $('#g3_num_stu').keyup(function () {
        discountCalculate('#g3_num_stu', '#g3_discount_price')
        totalAmountCalculate('#g3_cost_per_hour', '#g3_num_stu', '#g3_discount_price', '#g3_total_amount')
    });
    $('#g3_discount_price').keyup(function () {
        inputDiscount("#g3_cost_per_hour", "#g3_num_stu", "#g3_discount_price", "#g3_total_amount");
    });
    // ======= 4 =======
    $('#g4_hour').keyup(function () {
        costCalculate('#g4_hour', '#g4_cost_per_hour');
        totalAmountCalculate('#g4_cost_per_hour', '#g4_num_stu', '#g4_discount_price', '#g4_total_amount')
    });
    $('#g4_num_stu').keyup(function () {
        discountCalculate('#g4_num_stu', '#g4_discount_price')
        totalAmountCalculate('#g4_cost_per_hour', '#g4_num_stu', '#g4_discount_price', '#g4_total_amount')
    });
    $('#g4_discount_price').keyup(function () {
        inputDiscount("#g4_cost_per_hour", "#g4_num_stu", "#g4_discount_price", "#g4_total_amount");
    });
    // ======= 5 =======
    $('#g5_hour').keyup(function () {
        costCalculate('#g5_hour', '#g5_cost_per_hour');
        totalAmountCalculate('#g5_cost_per_hour', '#g5_num_stu', '#g5_discount_price', '#g5_total_amount')
    });
    $('#g5_num_stu').keyup(function () {
        discountCalculate('#g5_num_stu', '#g5_discount_price')
        totalAmountCalculate('#g5_cost_per_hour', '#g5_num_stu', '#g5_discount_price', '#g5_total_amount')
    });
    $('#g5_discount_price').keyup(function () {
        inputDiscount("#g5_cost_per_hour", "#g5_num_stu", "#g5_discount_price", "#g5_total_amount");
    });

    // ======= 6 =======
    $('#g6_hour').keyup(function () {
        costCalculate('#g6_hour', '#g6_cost_per_hour');
        totalAmountCalculate('#g6_cost_per_hour', '#g6_num_stu', '#g6_discount_price', '#g6_total_amount')
    });
    $('#g6_num_stu').keyup(function () {
        discountCalculate('#g6_num_stu', '#g6_discount_price')
        totalAmountCalculate('#g6_cost_per_hour', '#g6_num_stu', '#g6_discount_price', '#g6_total_amount')
    });
    $('#g6_discount_price').keyup(function () {
        inputDiscount("#g6_cost_per_hour", "#g6_num_stu", "#g6_discount_price", "#g6_total_amount");
    });
    // ======= 7 =======
    $('#g7_hour').keyup(function () {
        costCalculate('#g7_hour', '#g7_cost_per_hour');
        totalAmountCalculate('#g7_cost_per_hour', '#g7_num_stu', '#g7_discount_price', '#g7_total_amount')
    });
    $('#g7_num_stu').keyup(function () {
        discountCalculate('#g7_num_stu', '#g7_discount_price')
        totalAmountCalculate('#g7_cost_per_hour', '#g7_num_stu', '#g7_discount_price', '#g7_total_amount')
    });
    $('#g7_discount_price').keyup(function () {
        inputDiscount("#g7_cost_per_hour", "#g7_num_stu", "#g7_discount_price", "#g7_total_amount");
    });

    $('#g1_hour, #g1_num_stu,#g2_hour, #g2_num_stu,#g3_hour, #g3_num_stu,#g4_hour, #g4_num_stu,#g5_hour, #g5_num_stu,#g6_hour, #g6_num_stu,#g7_hour, #g7_num_stu,#g1_discount_price,#g2_discount_price,#g3_discount_price,#g4_discount_price,#g5_discount_price,#g6_discount_price,#g7_discount_price').keyup(function () {
        var g1 = parseFloat($('#g1_total_amount').text()) || 0;
        var g2 = parseFloat($('#g2_total_amount').text()) || 0;
        var g3 = parseFloat($('#g3_total_amount').text()) || 0;
        var g4 = parseFloat($('#g4_total_amount').text()) || 0;
        var g5 = parseFloat($('#g5_total_amount').text()) || 0;
        var g6 = parseFloat($('#g6_total_amount').text()) || 0;
        var g7 = parseFloat($('#g7_total_amount').text()) || 0;

        var sum_value = g1 + g2 + g3 + g4 + g5 + g6 + g7;

        // Subtotal 
        $('#subtotal').text((sum_value).toFixed(2));
        var vat_value = (sum_value * 10 / 100);

        // Vat
        $('#vat_total').text((vat_value).toFixed(2));

        // total
        var total_value = (sum_value + vat_value).toFixed(2);
        $('#total').text(total_value);
    });

});
function costCalculate(g_hour, g_cost_per_hour) {
    var cost = 0;
    var hour = parseFloat($(g_hour).val()) || 0;
    if (hour >= 6) {
        if ($(g_hour).hasClass('error')) {
            $(g_hour).removeClass('error');
        }

        if (hour <= 10) {
            cost = 12;
        }
        else if ((hour >= 11) && (hour <= 15)) {
            cost = 11;
        }
        else if ((hour >= 16) && (hour <= 20)) {
            cost = 10;
        }
        else if ((hour >= 21) && (hour <= 25)) {
            cost = 9.5;
        }
        else if ((hour >= 26) && (hour <= 30)) {
            cost = 9;
        }
        else if ((hour >= 31) && (hour <= 35)) {
            cost = 8.5;
        }
        else {
            cost = 8;
        }
    } else {
        $(g_hour).addClass('error');
    }
    $(g_cost_per_hour).text((cost * hour).toFixed(2));

}
function discountCalculate(g_num_stu, g_discount_price) {
    var num_stu = parseFloat($(g_num_stu).val()) || 0;
    var discount = 0;
    if (num_stu >= 8) {
        if (num_stu <= 36) {
            discount = 15;
        } else if (num_stu >= 37 && num_stu <= 60) {
            discount = 20;
        } else {
            discount = 25;
        }
    }
    $(g_discount_price).val(discount);

}
function inputDiscount(g_cost, g_num_stu, g_discount_price, g_total_amount) {
    var discount = parseFloat($(g_discount_price).val()) || 0;
    if (discount >= 15 && discount <= 100) {
        if ($(g_discount_price).hasClass('error')) {
            $(g_discount_price).removeClass('error');
        }
        totalAmountCalculate(g_cost, g_num_stu, g_discount_price, g_total_amount)
    } else {
        $(g_discount_price).addClass('error');
    }
}
function totalAmountCalculate(g_cost, g_num_stu, g_discount_price, g_total_amount) {
    var discount = parseFloat($(g_discount_price).val()) || 0;
    var cost = parseFloat($(g_cost).text());
    var num_stu = parseFloat($(g_num_stu).val()) || 0;
    console.log(discount, 'discount')
    console.log(cost, 'cost')
    console.log(num_stu, 'num_stu')

    if (discount != 0) {
        $(g_total_amount).text(((cost * num_stu) - (cost * num_stu) * discount / 100).toFixed(2));

    } else {
        $(g_total_amount).text((cost * num_stu).toFixed(2));
    }
}

